import React, { useEffect } from 'react';
import { INavLink } from '@hwm/ui-lib';
import { useGetLinks } from './MainMenu.utils';

export interface MainMenuProps {
  links: INavLink[];
  setLinks: (links: INavLink[]) => void;
}

export const MainMenu: React.FC<MainMenuProps> = ({ links, setLinks }) => {
  const { getMenu } = useGetLinks();

  useEffect(() => {
    if (links.length > 0) {
      links.splice(0, links.length);
    }

    links.push(...getMenu());
    setLinks(getMenu());
  }, [links, getMenu, setLinks]);

  return <></>;
};
